import { IcPhone } from '@assets/icons/40x40';
import { HStack, Icon, Text } from '@chakra-ui/react';
import PopupContainer from '@components/map/popup/common/PopupContainer';
import { FormattedMessage } from 'react-intl';

import { SensorOrSubSensorConfiguration } from '@/types/sensor/configuration.types';

type Props = {
  configuration: SensorOrSubSensorConfiguration;
};

export default function EmergencySensorPhoneNumber({ configuration }: Readonly<Props>) {
  if (!('phoneNumber' in configuration) || configuration.phoneNumber === null || configuration.phoneNumber === '') {
    return null;
  }
  return (
    <PopupContainer>
      <HStack width="100%" gap={1.5}>
        <Icon as={IcPhone} boxSize={{ base: '24px', '4k': '32px' }} color="neutral.500" />
        <Text textStyle="screenStd">
          <FormattedMessage id="sensors.emergency" />
        </Text>
        <Text textStyle="screenLg" marginLeft="auto">
          {configuration.phoneNumber}
        </Text>
      </HStack>
    </PopupContainer>
  );
}
